module.exports = __webpack_public_path__ + "static/tesla-solar-roof-2-1080w-cb6b2af0a7af55611d4e6b0570e55b0e.jpg";